
import { defineComponent } from 'vue';
import {
  Typography,
  Select,
  Button,
} from 'ant-design-vue';
import { mapGetters } from 'vuex';
import {
  CaretDownFilled,
} from '@ant-design/icons-vue';

const { Title } = Typography;
const { Option } = Select;

export type responseStatus = 'approved' | 'rejected' | undefined;

export default defineComponent({
  name: 'RawDataRequestAdminAdditional',
  components: {
    Button,
    Select,
    Title,
    Option,
    CaretDownFilled,
  },
  data() {
    return {
      response: undefined as responseStatus,
      message: '',
    };
  },
  props: {
    version: {
      type: Number,
      required: true,
    },
    requestUuid: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: 'user/getIsAdmin',
    }),
  },
  methods: {
    confirmResponse() {
      if (this.response) {
        const {
          version,
          requestUuid,
          response,
          message,
          $router,
        } = this;
        let body: {status: string, rejectionMessage?: string } = { status: response };
        if (response === 'rejected') {
          body = {
            status: response,
            rejectionMessage: message,
          };
        }
        this.$store.dispatch('rawDataRequests/respondToRawDataRequest', {
          version,
          requestUuid,
          body,
        }).then(() => $router.go(0));
      }
    },
  },
});
